// Legacy cleanup only. New Deploy API-key secrets are deliberately never put
// in browser storage: the dashboard shows a newly minted key once from React
// memory, then the customer stores it in their local coding tool.
export const LEGACY_DEPLOY_MCP_TOKEN_KEYS = ["rdMcpToken", "rdMcpKeyId"];

export function clearLegacyDeployMcpToken(storage) {
  try {
    const target = storage || (typeof window !== "undefined" ? window.localStorage : null);
    if (!target) return false;
    LEGACY_DEPLOY_MCP_TOKEN_KEYS.forEach((key) => target.removeItem(key));
    return true;
  } catch {
    return false;
  }
}
